export enum EStoreType{
    Hypermarket,
    Supermarket,
    Convenient,
    Discounter,
    None
}